import { TTipVariant, TTipPlacement } from "./Tips.types";

export const getVariantClasses = (variant: TTipVariant) => {
  switch (variant) {
    case "primary":
      return "bg-icon-tertiary text-onColor";
    case "secondary":
      return "bg-primary text-secondary border border-primary";
    default:
      return "bg-icon-tertiary text-onColor";
  }
};

export const getPlacementClasses = (placement: TTipPlacement) => {
  switch (placement) {
    case "top":
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
    case "bottom":
      return "top-full left-1/2 transform -translate-x-1/2 mt-2";
    case "left":
      return "right-full top-1/2 transform -translate-y-1/2 mr-2";
    case "right":
      return "left-full top-1/2 transform -translate-y-1/2 ml-2";
    default:
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
  }
};

export const getTriangleClasses = (placement: TTipPlacement) => {
  switch (placement) {
    case "top":
      return "-bottom-2 left-1/2 transform -translate-x-1/2 rotate-45";
    case "bottom":
      return "-top-2 left-1/2 transform -translate-x-1/2 -rotate-[135deg]";
    case "left":
      return "-right-2 top-1/2 transform -translate-y-1/2 -rotate-45";
    case "right":
      return "-left-2 top-1/2 transform -translate-y-1/2 rotate-[135deg]";
    default:
      return "-bottom-2 left-1/2 transform -translate-x-1/2 rotate-45";
  }
};

export const getTriangleVariantClasses = (variant: TTipVariant) => {
  switch (variant) {
    case "primary":
      return "bg-icon-tertiary";
    case "secondary":
      return "bg-primary border-r border-b border-primary h-[6.5px] w-[6.5px]";
    default:
      return "bg-icon-tertiary";
  }
};
